import { Model } from "survey-core";
import { forkJoin } from "rxjs";
import { uploadFile, downFile, deleteFile } from "../../../network/network";
import { StorageFileTypeEnum } from "../../../network/file-op-interface";
import { ActionStatusEnum } from "./action-enum";
import { handleBase64Url, toBase64Url, base64ToBlob } from "./base64";
import { get, isString } from "lodash";
import store from "../../../../../redux/store";
import { GlobalHelper } from "../../../../../utils/helpers/global-helper";

export function initFileUploadAndDownLoadAndClear(survey: Model): void {
  survey.onUploadFiles.clear();
  survey.onDownloadFile.clear();
  survey.onClearFiles.clear();
  survey.onUploadFiles.add((_, options) => {
    const questionName = options.question.name;
    const sectionName = options.question.parent.name;
    const moduleName = GlobalHelper.getOnboardingCurrentSection()?.moduleName;
    const applicationId = store.getState()?.onboarding?.candidateOnboardingForm?.applicationId;
    const fileType =
      options.question.getType() === "signaturepad"
        ? StorageFileTypeEnum.SIGNATURE
        : StorageFileTypeEnum.UPLOAD_DOCUMENT;
    const fileOb = options.files.map((file) => {
      return new Promise((resolve, reject) => {
        const upload = async (blob: Blob, fileName: string, mimeType: string) => {
          try {
            // const base64R = handleBase64Url(base64URL);
            const result = await uploadFile({
              moduleName,
              sectionName,
              applicationId,
              questionName,
              fileName: options.question.getType() === "signaturepad" ? "signature.png" : fileName,
              index: get(file, "index", 0),
              fileType,
              file: blob,
              mimeType,
            });
            resolve(result.data);
          } catch {
            resolve(ActionStatusEnum.error);
          }
        };
        if (isString(file)) {
          const { base64, mimetype } = handleBase64Url(file);
          upload(base64ToBlob(base64, mimetype), get(file, "name", ""), mimetype);
        } else {
          upload(file, file.name, file.type);
        }
      });
    });
    forkJoin(fileOb).subscribe((value) => {
      const values = value.filter((v) => v !== ActionStatusEnum.error);
      if (values.length === 0) {
        options.callback(ActionStatusEnum.error, undefined);
        return;
      }
      options.callback(ActionStatusEnum.success, values);
    });
  });
  survey.onDownloadFile.add(async (_, options) => {
    try {
      const applicationId = store.getState()?.onboarding?.candidateOnboardingForm?.applicationId;
      const result = await downFile({
        applicationId,
        resourceId: options.content,
      });
      if (result.data) {
        const content = result.data.fileContent as string;
        const mimeType = result.data.mimeType as string;
        const base64URL = toBase64Url(content, mimeType);
        const fileName = result.data.fileName as string;
        options.callback(ActionStatusEnum.success, {
          base64URL,
          fileName,
          mimeType,
        });
      }
    } catch {
      options.callback(ActionStatusEnum.error);
    }
  });
  survey.onClearFiles.add(async (_, options) => {
    try {
      const applicationId = store.getState()?.onboarding?.candidateOnboardingForm?.applicationId;
      if (!applicationId || !options.fileName) {
        options.callback(ActionStatusEnum.success, "");
        return;
      }
      const result = await deleteFile({
        applicationId,
        resourceId: options.fileName,
      });
      if (result.data) {
        options.callback(ActionStatusEnum.success, "");
      } else {
        options.callback(ActionStatusEnum.error, "");
      }
    } catch (error) {
      options.callback(ActionStatusEnum.error, "");
    }
  });
}
